/**
 * The only thing this plugin does is check on paste to see if a sortable table has been pasted
 * from a view page and if it has, revert it back into something the editor has an easy time manipulating.
 */

import window from 'window-or-global';
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

const plugin = {
	init: (ed) => {
		const postPasteHandler = (ev) => {
			const tables = $('.tablesorter', ev.node);
			tables.each((i, current) => {
				let thead = $(current).find('thead');
				let tbody;
				let firstTr;

				if (thead.length !== 1) {
					return;
				}
				thead = thead[0];

				if (thead.nodeName === 'THEAD' && thead.childNodes.length === 1) {
					firstTr = thead.removeChild(thead.childNodes[0]);
					tbody = $(current).find('tbody')[0];
					current.removeChild(thead);
					tbody.insertBefore(firstTr, tbody.childNodes[0]);
				}
			});
		};

		ed.on('PastePostProcess', postPasteHandler);

		ed.on('remove', () => {
			ed.off('PastePostProcess', postPasteHandler);
		});
	},
	getInfo: () => {
		return {
			longname: 'ConfluenceSortableTablesPlugin',
			author: 'Atlassian',
			authorurl: 'http://www.atlassian.com',
			infourl: 'http://www.atlassian.com',
			version: '1.0',
		};
	},
};

export default () => {
	window.tinymce.create('tinymce.plugins.ConfluenceSortableTablesPlugin', plugin);
	window.tinymce.PluginManager.add(
		'confluencesortabletablesplugin',
		window.tinymce.plugins.ConfluenceSortableTablesPlugin,
	);
};
